import {Component, ViewChild, HostListener} from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { LoginPage } from "../pages/login/login";
import { OrdersPage } from "../pages/orders/orders";
import { PvPage } from "../pages/pv/pv";
import {DataProvider} from "../providers/data/data";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  pages: Array<{title: string, component: any}>;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public data: DataProvider) {
    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Aufträge', component: OrdersPage },
      { title: 'PV ansehen', component: PvPage }
    ];

    this.data.last_touchstart = Math.round(new Date().getTime()/1000);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  @HostListener('touchstart', ['$event'])
  onStart(event) {
    this.data.last_touchstart = Math.round(new Date().getTime()/1000);
    this.data.checkInterval();
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts